import React from 'react';
import { NavLink } from 'react-router-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Home from './components/Home';
import Research from './components/Research';
import CurriculumVitae from './components/CurriculumVitae';

import './App.css';

function App() {
	return (
		<div className='App'>
			<BrowserRouter>
				<nav className='navbar navbar-expand-lg navbar-light bg-light'>
					<button
						className='navbar-toggler'
						type='button'
						data-toggle='collapse'
						data-target='#navbarSupportedContent'
						aria-controls='navbarSupportedContent'
						aria-expanded='false'
						aria-label='Toggle navigation'
					>
						<span className='navbar-toggler-icon'></span>
					</button>

					<div className='collapse navbar-collapse' id='navbarSupportedContent'>
						<ul className='navbar-nav m-auto'>
							<li className='nav-item'>
								<NavLink className='nav-link ml-5' to='/'>
									Home
								</NavLink>
							</li>
							<li className='nav-item'>
								<NavLink className='nav-link ml-5' to='/research'>
									Research
								</NavLink>
							</li>
							<li className='nav-item'>
								<NavLink className='nav-link ml-5' to='/software-projects'>
									Software Projects
								</NavLink>
							</li>
							<li className='nav-item'>
								<NavLink className='nav-link ml-5' to='/curriculum-vitae'>
									Curriculum Vitae
								</NavLink>
							</li>
							<li className='nav-item'>
								<NavLink className='nav-link ml-5' to='/contacts'>
									Contacts
								</NavLink>
							</li>
						</ul>
					</div>
				</nav>

				<div className='container-fluid'>
					<Switch>
						<Route exact path='/' component={Home} />
						<Route path='/research' component={Research} />
						<Route path='/curriculum-vitae' component={CurriculumVitae} />
					</Switch>
				</div>

				<div className='footer text-center'>
					Copyright &copy; Debajyoti Karmaker 2020
				</div>
			</BrowserRouter>
		</div>
	);
}

export default App;
